exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-bar[data-v-a68fe3c2]{align-items:center;justify-content:space-between;padding-bottom:1rem;color:#504e4e}.title[data-v-a68fe3c2]{font-size:14px}[data-v-a68fe3c2] .van-grid-item__content{padding:4px;background-color:#f2f2f2;border:1px solid #dedede}[data-v-a68fe3c2] .van-grid-item__text{font-family:PingFangSC-Regular;font-size:12px;color:#7d7d7d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a68fe3c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/SearchHistoryBar.vue
// module id = 880
// module chunks = 0